import { render, staticRenderFns } from "./RequestCard.vue?vue&type=template&id=01e6e6eb&scoped=true"
import script from "./RequestCard.vue?vue&type=script&lang=js"
export * from "./RequestCard.vue?vue&type=script&lang=js"
import style0 from "./RequestCard.vue?vue&type=style&index=0&id=01e6e6eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e6e6eb",
  null
  
)

export default component.exports